import { type ResultOf } from '@graphql-typed-document-node/core'
import { atomWithReset } from 'jotai/utils'

import { graphql } from '~/gql'
import { type CustomizedAnalysisPage_TabulationMutationMutationVariables as MutationVariables } from '~/gql/graphql'

export const isTabulationReadyAtom = atomWithReset(false)
export const isPendingTabulationAtom = atomWithReset(false)

const tabulationQueryDataFragment = graphql(`
  fragment CustomizedAnalysisPage_TabulationQueryData on CountCustomizedAnalysisResult {
    answers {
      ...GroupCountsFigures_QuestionTabulationQueryData
    }
    brands9segs {
      id
      name
      number
      result {
        count
        segmentNumber
      }
    }
    customerAttributes {
      ...GroupCountsFigures_CustomerAttributeTabulationQueryData
    }
  }
`)

export const tabulationQueryDataAtom = atomWithReset<ResultOf<
  typeof tabulationQueryDataFragment
> | null>(null)

export const lastTabulatedVariablesAtom =
  atomWithReset<MutationVariables | null>(null)
